<template>
  <label for="image-input"
         class="with-line"
  ><span>{{ $t("spotdetail.add_image_text") }}</span>
  </label>
  <div
      v-if="images.length > 0"
      class="grid grid-cols-3 w-full min-h-6 py-1 gap-1"
  >
    <div v-if="!spot.famed" v-for="id in images" class="checkboxlabel flex flex-col gap-1">
        <SpotEditImagePreview :id="id" @delete="deleteImage(id)"/>
        <label :for="name+'-checkbox-' + id"  class="flex items-center justify-center">
          <input
              type="checkbox"
              name="showsFix"
              :id="name+'-checkbox-' + id"
              :value="id"
              class="mov-checkbox"
              v-model="showFixImageIds"
          />
          <span>{{ $t("spotdetail.add_image_shows_fix") }}</span>
      </label>

    </div>
    <div v-else v-for="id in images">
      <SpotEditImagePreview :id="id" @delete="deleteImage(id)"/>
    </div>
    <SpotEditImagePreviewLoading v-if="uploadingImage"/>
  </div>
  <div class="mb-2" v-else>
    <p>{{ $t("spotdetail.add_image_no_images") }}</p>
  </div>
  <input
      ref="imageUploader"
      class="hidden"
      type="file"
      :id="name+'-image-input'"
      name="image"
      accept="image/png, image/jpeg"
      @change="onFileChanged($event)"
  />
  <ButtonSubmit
      @click="imageUploader.click()"
      :loading="uploadingImage"
      :error="uploadingImageError!==undefined"
      :error-message="uploadingImageError"
      :title="$t('spotdetail.add_image_select')"
  />

  <ButtonSubmit
      :disable-submit="images.length < 1"
      @click="addImages"
      :loading="addingImages"
      :error="addingImagesError"
  />
</template>
<script setup lang="ts">

const props = defineProps<{ spot: SpotDetail, name: string }>()
const {t} = useI18n();
const images = ref<number[]>([]);
const file = ref<File>();
const uploadingImage = ref<boolean>(false);
const uploadingImageError = ref<string | undefined>();
const addingImages = ref<boolean>(false);
const addingImagesError = ref(false);
const showFixImageIds = ref<Array<number>>([]);
const imageUploader = ref<HTMLInputElement | null>(null);

const emit = defineEmits(["success"]);

const onFileChanged = ($event: Event) => {
  const target = $event.target as HTMLInputElement;
  if (target && target.files) {
    file.value = target.files![0];

    if (file.value?.size > 10000000) {
      uploadingImage.value = false;
      uploadingImageError.value = t("error.file_to_large");
      setTimeout(() => {
        uploadingImageError.value = undefined;
      }, 2000);
    } else {
      uploadImage();
    }
    imageUploader.value!.value = '';
  }
};

const uploadImage = () => {
  if (file.value) {
    uploadingImage.value = true;
    uploadingImageError.value = undefined
    let formData = new FormData();

    formData.append("file", file.value!);

    useApiAuth()
        .post<number>("images/upload", formData)
        .then((response) => {
          uploadingImage.value = false;
          if (response) {
            images.value.push(response);

          }
        })
        .catch((error) => {
          uploadingImage.value = false;
          uploadingImageError.value = t("error.generic");
          console.log(error);
        });
  }
};

const deleteImage = (id: number) => {
  useApiAuth().del("images/" + id.toString()).then((response) => {
    images.value = images.value.filter((image) => image != id);
  });
};

const addImages = () => {
  addingImages.value = true;
  addingImagesError.value = false;
  if (images.value.length > 0) {
    const formData = new FormData();
    images.value.forEach((id) => {
      formData.append("imageIds[]", id.toString());
      if (showFixImageIds.value.includes(id))
        formData.append("showsFix[]", true.toString());
      else formData.append("showsFix[]", false.toString());
      formData.append("showsFix[]", false.toString());
    });
    formData.append("frontImageId", "0");

    useApiAuth()
        .post<SpotAddImagesResponse>(
            "spots/" + props.spot.id + "/images",
            formData
        )
        .then((response) => {
          if (response) {
            props.spot.gallery.push(...response.images);
            props.spot.gotFixed = response.spotGotFixed;
            addingImages.value = false;
            images.value = [];
            emit("success");
          }
        })
        .catch((error) => {
          console.log(error);
          addingImages.value = false;
          addingImagesError.value = true;
        });
  }
};
</script>
<style scoped lang="postcss">
.checkboxlabel {
  @apply flex flex-col items-center justify-center;
}

.with-line {
  @apply border-b border-b-theme-secondary/30;
}

.delete-image-btn:hover {
  circle {
    @apply fill-black transition-all duration-200;
  }

  path {
    @apply stroke-white transition-all duration-200;
  }

  @apply hover:shadow-none;
}

</style>
